import { inputBorderRadiusMedium, inputBorderRadiusSmall } from "src/styles/components/constants";
import { SenecBaseTheme } from "src/styles/senecBaseTheme";

export const customTextFieldStyles = (theme: SenecBaseTheme) => {
    return {
        "input, .MuiSelect-select": {
            px: "16px",
        },

        // Styles for size medium
        "&.SenecTextField-medium": {
            "input, textarea, label": {
                ...theme.typography.body1,
            },
            ".MuiInputBase-root, .MuiOutlinedInput-notchedOutline": {
                borderRadius: inputBorderRadiusMedium,
            },
            "&.SenecTextField-with-Label": {
                label: { top: 0 },
                input: { pt: "20px" },
                textarea: { pt: "5px" },
                ".MuiInputLabel-shrink": {
                    top: 0,
                    left: "2px",
                },
            },

            minHeight: "60px",
            ".MuiInputBase-root:not(.MuiInputBase-multiline)": {
                minHeight: "60px",
                maxHeight: "60px",
            },
        },

        // Styles for size small
        "&.SenecTextField-small": {
            ".MuiInputBase-root, .MuiOutlinedInput-notchedOutline": {
                borderRadius: inputBorderRadiusSmall,
            },
            "input, textarea, label": {
                ...theme.typography.enbwTabletS1,
            },
            "&.SenecTextField-with-Label": {
                label: { top: "-2px" },

                ".MuiInputLabel-shrink": {
                    display: "none",
                },
            },

            minHeight: "40px",
            ".MuiInputBase-root:not(.MuiInputBase-multiline)": {
                minHeight: "40px",
                maxHeight: "40px",
            },
            ".MuiInputBase-input": {
                transform: "translateY(1px)",
            },
        },

        // Styles for without label
        "&.SenecTextField-without-Label": {
            ".MuiInputBase-input, .MuiInputBase-root input, .MuiInputBase-root textarea": {
                transform: "translateY(1px)",
            },
        },

        // Styles for filled
        "&.SenecTextField-filled": {
            ".MuiInputBase-root": {
                background: `${theme.palette.neutralGray20.main}`,
                ".MuiOutlinedInput-notchedOutline": {
                    borderColor: theme.palette.neutralGray05.main,
                },
                "&:hover": {
                    background: theme.palette.neutralGray05.main,
                    ".MuiOutlinedInput-notchedOutline": {
                        borderColor: `${theme.palette.neutralGray20.main}`,
                    },
                },
                "&.Mui-focused": {
                    background: theme.palette.white.main,
                    "fieldset.MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.palette.deepBlue.main,
                        borderWidth: "1px",
                    },
                },
            },
        },
    };
};
